module.exports = __webpack_public_path__ + "img/dsci0041.cdfaf1b3.jpg";